
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { Toolbar } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom/cjs/react-router-dom';

const useStyles = makeStyles(theme => ({
    root: {
		height: '20px',
		minHeight: '20px',
		backgroundColor:'red',
		color: 'white',
		display: 'flex',
		flexDirection: 'row',
		justifyContent:'space-between'
	},
	closeButton:{
		color: 'white',
		cursor: 'pointer'
	},
	message:{
		color: 'yellow'
	},
	pricingLink:{
		color: 'white !important'
	}
}));

function LicenseNotificationBar(props) {
	const classes = useStyles(props);
    const { t } = useTranslation('aiaas');

	const closeToolbar = ()=>{
		sessionStorage.setItem('hide-license-notification-bar','true')
		props.closeNotificationToolbar()
	}

	return (
		<Toolbar variant="dense"  classes={classes}
		>
			<div>
				<span className={clsx(classes.message)}>{t('expiredLicenseNotification.message')}</span>
				<span>
					<Link to='/pricing' className={clsx(classes.pricingLink)}>{t('expiredLicenseNotification.pricing')}</Link>
				</span>
			</div>
			<Icon onClick={closeToolbar} className={clsx(classes.closeButton)}>close</Icon>
		</Toolbar>
	);
}

export default LicenseNotificationBar;
